
import React from 'react';
import { cn } from '@/lib/utils';
import 'react-quill/dist/quill.bubble.css';

type RichContentRendererProps = {
  content: string;
  className?: string;
};

const RichContentRenderer = ({ content, className = '' }: RichContentRendererProps) => {
  return (
    <div 
      className={cn(
        'prose prose-sm max-w-none',
        'prose-headings:font-bold prose-headings:tracking-tight',
        'prose-a:text-primary prose-a:underline hover:prose-a:text-primary/80',
        'prose-blockquote:border-l-primary/50 prose-blockquote:bg-muted/50 prose-blockquote:px-4 prose-blockquote:py-1',
        'prose-code:rounded-md prose-code:bg-muted prose-code:px-1.5 prose-code:py-0.5 prose-code:font-mono prose-code:text-sm',
        'prose-img:rounded-lg prose-img:max-w-full prose-img:h-auto',
        className
      )}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default RichContentRenderer;
